export const levelUpAnalyticsOtherActions = {
  INITIALIZE_STATE: 'INITIALIZE_STATE',
  CHANGE_VIEW: 'CHANGE_VIEW',
  SET_EXPANSION_VIEW_DETAILS: 'SET_EXPANSION_VIEW_DETAILS',
  CLEAR_EXPANSION_VIEW_DETAILS: 'CLEAR_EXPANSION_VIEW_DETAILS',
  SET_NO_DATA: 'SET_NO_DATA',
  SET_ERROR_DATA: 'SET_ERROR_DATA',
  SET_GROUP_BY_KEYS: 'SET_GROUP_BY_KEYS',
};

export const levelUpAnalyticsFilterActions = {
  SELECT_COHORT: 'SELECT_COHORT',
  SELECT_GROUPBY: 'SELECT_GROUPBY',
  SELECT_SPLIT_BY_KEY: 'SELECT_SPLIT_BY_KEY',
  SELECT_DATERANGE: 'SELECT_DATERANGE',
  SELECT_TIMEBOUND_PERIODS: 'SELECT_TIMEBOUND_PERIODS',
  SET_OPERATION_IN_PROGRESS: 'SET_OPERATION_IN_PROGRESS',
};

export const levelUpAnalyticsCohortCreationActions = {
  SHOW_SIDEPANEL: 'SHOW_SIDEPANEL',
  HIDE_SIDEPANEL: 'HIDE_SIDEPANEL',
  ADD_COHORT: 'ADD_COHORT',
};

export const levelUpAnalyticsConstantsActions = {
  SET_LEVEL_UP_RISK_ESTIMATION_LIST: 'SET_LEVEL_UP_RISK_ESTIMATION_LIST',
  SET_LEVEL_UP_PROGRESS_STATUSES: 'SET_LEVEL_UP_PROGRESS_STATUSES',
};
